import axios from "axios";

export default class ConnectionManager2 {
    game = null;
    lastUpdate = null;
    subscribers = [];
    statssubscribers = [];
    subscribersSensor = [];
    player_id = null;
    gameStats = null;

    constructor(game, player_id) {
        console.log(game);
        this.game = game;
        this.player_id = player_id;
        this.setCurrentGameID();
        Echo.private('games.' + game.id)
            .listen('.game.nextplayer', (e) => {
                //command next player was received
            })

            .listen('.game.gamestate', (e) => {
                //get the current game state
                this.lastUpdate = e;
                this.updateSubscribers(e);
                console.log(e)
            })

            .listen('.game.gameNumpadInput', (e) => {
                //get the current game state
                console.log(e)
            })

            .listen('.game.errorstate', (e) => {
                if (e.player == this.player_id) {
                    console.log(e);
                    this.updateSubscribers(e);
                    toastError(e.errorState);
                }
            })

            .listen('.game.sendsinglescore', (e) => {
                //get a single score from a client
                console.log(e)
            })

            .listen('.game.proposerematch', (e) => {
                this.proposeRematch(e)
            })

            .listen('.game.gamestatistics', (e) => {
                //get the game statistics of ended game
                this.lastUpdate = e;
                this.updateSubscribers(e);
                // console.log(e)
            })
            .listen('.game.sensor', (e) => {
                this.updateSubscribersSensor(e);
            })
            .listen('.game.stuckdart', (e) => {
                this.updateSubscribersSensor(e);
            })

        Echo.join('gamestate.' + game.id)
            .here(users => {
                //this player has joined the channel
                this.requestGameState();
            })
            .joining(user => {
                //another player has joined the channel
            })
            .leaving(user => {
                //another player has left the channel
            })
        window.connection = this;
    }

    setCurrentGameID() {
        axios.post('/api/users/current_game/' + this.game.id);
    }

    //send a request to get the current game state
    requestGameState() {
        axios.get("/api/games/" + this.game.id + "/gamestate");
    }

    subscribe(ent) {
        this.subscribers.push(ent);
    }

    subscribeSensor(ent) {
        this.subscribersSensor.push(ent);
    }

    statssubscribe(ent) {
        this.statssubscribers.push(ent);
    }

    updateSubscribers(event) {
        this.subscribers.forEach(sub => {
            sub.update(event);
        });
    }

    updateStatisticsSubscribers(event) {
        this.statssubscribers.forEach(sub => {
            sub.update(event);
        });
    }

    updateSubscribersSensor(event) {
        this.subscribersSensor.forEach(sub => {
            sub.update(event);
        });
    }

    proposeRematch(e) {
        this.onProposeRematch(e);
    }

    resetLeg() {
        axios.post('/api/debug/resetLeg');
    }
}
